module.exports = {"TXTWCL_Unlock":{"id":"TXTWCL_Unlock","defaultMessage":"Feloldás","flags":["TRACK"],"track":"Unlock"}}